import { useMutation } from "@tanstack/react-query";
import { toastr } from "react-redux-toastr";

import { client, getApiErrorMessage } from "utils/api";

const useUpdate = ({
  path,
  onSuccess,
  onError,
  success_message = "Zaktualizowano pomyślnie",
  createSuccessMessage,
  success_message_enabled = true,
  error_message_enabled = true,
}) => {
  const { isPending: is_updating, mutateAsync: update } = useMutation({
    mutationFn: (values) => client.put(path, values),
    onSuccess: ({ data }) => {
      if (success_message_enabled) {
        toastr.success(
          "Sukces",
          typeof createSuccessMessage == "function"
            ? createSuccessMessage(data)
            : success_message
        );
      }

      onSuccess?.(data);
    },
    onError: (err) => {
      if (error_message_enabled) {
        toastr.error("Błąd", getApiErrorMessage(err));
      }
      onError?.(err);
    },
  });

  return { is_updating, update };
};

export default useUpdate;
